<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Cidadãos desatualizados"
            description="Pessoas com mais de um ano sem atualização no CADSUS"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <tabela-cadastros-vuetfy
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros-vuetfy>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'
import utils from '@/mixins/utils.js'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'

export default {
  name: 'CidadaosDesatualizados',
  components: {
    Menu,
    Footer,
    SectionTitle,
    TabelaCadastrosVuetfy,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },

    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipe: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      cadastros: [],
      cadastrosOriginais: [],
      filterSearchTable: false,
    }
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async buscarDadosIniciais() {
      try {
        this.loading = true

        let cidadados_desatualizados = await this.$api.get(
          '/app/cidadaos-desatualizados/' +
            this.cod_ibge +
            '/' +
            this.$store.state.nu_ine
        )
        this.cadastros = []
        this.cadastros = cidadados_desatualizados.data
        this.cadastrosOriginais = cidadados_desatualizados.data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },

    /* Retorna a diferença de dias entre a data atual e a data passada como parâmetro */
    diffDates(date) {
      return this.differenceOfDaysBetweenTwoDates(
        date,
        this.ultimaAtualizacao.split('/').reverse().join('-')
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
